import * as React from "react";
import type { SVGProps } from "react";
const SvgPlus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 18 18"
    fill={props.color || "#F7F7F8"}
    {...props}
  >
    <path
      d="M18 9a.75.75 0 0 1-.75.75h-7.5v7.5a.75.75 0 1 1-1.5 0v-7.5H.75a.75.75 0 0 1 0-1.5h7.5V.75a.75.75 0 0 1 1.5 0v7.5h7.5A.75.75 0 0 1 18 9"
    />
  </svg>
);
export default SvgPlus;
